import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RulerIcon } from '@cdl/heartbeat-react';
import { setActiveTool } from '../../tool/actions/tool.actions';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import { initializeRuler } from '../thunks/initialize-ruler.thunk';
import * as analyticsInfoActions from '../../analytics/actions/analytics-info.actions';
import { trackUseRuler } from '../../analytics/thunks/track-use-ruler.thunk';
import { trackStopRuler } from '../../analytics/thunks/track-stop-ruler.thunk';
import { ToolButton } from '../../../features/tool/components/ToolButton';

export const RulerTool: React.FC = () => {
  const dispatch = useDispatch();
  const isRulerActive = useSelector(
    isToolActiveSelector(Tool.ruler, Tool.rulerAnchored),
  );

  const activateRuler = () => {
    dispatch(
      analyticsInfoActions.setRulerInteraction({ interaction: 'click' }),
    );
    dispatch(initializeRuler());
    dispatch(isRulerActive ? trackStopRuler('click') : trackUseRuler('click'));
    dispatch(
      setActiveTool({
        tool: isRulerActive ? null : Tool.ruler,
        meta: { history: false },
      }),
    );
  };

  return (
    <ToolButton
      label='Ruler'
      onClick={activateRuler}
      isActive={isRulerActive}
      aria-label='Ruler'
      icon={<RulerIcon />}
    />
  );
};
